import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-tryout-total-earnings',
  templateUrl: './tryout-total-earnings.component.html',
  styleUrls: ['./tryout-total-earnings.component.css']
})
export class TryoutTotalEarningsComponent implements OnInit {

  @Input() TotalEarnings: number;

  //@Output() filterProgramsEvent = new EventEmitter();
  //program_status = '';

  constructor() { }

  ngOnInit() {
  }

  //filterProgramListing(value) {
  //  this.program_status = value;
  //  //this.filterProgramsEvent.emit(this.program_status);
  //}
}



// WEBPACK FOOTER //
// ./src/app/tryout/components/tryout-total-earnings/tryout-total-earnings.component.ts